import * as useSignInModule from "./hooks/useSignIn";
import * as authUtilsModule from "./utils/authUtils";
import * as authCacheModule from "./utils/AuthCache";
import * as userPropertiesModule from "./utils/UserProperties";
import * as privateRouteModule from "./components/PrivateRoute";
export var useSignIn = useSignInModule.default;
export var UserPropertyKeys = userPropertiesModule.UserPropertyKeys;
export * from "./utils/UserGroups";
export var checkForcedLogout = authUtilsModule.checkForcedLogout;
export var logOut = authUtilsModule.logOut;
export var logOutOthers = authUtilsModule.logOutOthers;
export var handleForcedLogout = authUtilsModule.handleForcedLogout;
export var getCurrentUser = authUtilsModule.getCurrentUser;
export var getCurrentUserAttribute = authUtilsModule.getCurrentUserAttribute;
export var updateCurrentUserAttribute = authUtilsModule.updateCurrentUserAttribute;
export var isCurrentUserAuthenticated = authUtilsModule.isCurrentUserAuthenticated;
export var getIDTokenAsString = authUtilsModule.getIDTokenAsString;
export var ensureUserHasId = authUtilsModule.ensureUserHasId;
export var AuthCache = authCacheModule.default;
export var PrivateRoute = privateRouteModule.PrivateRoute;
